/**
 * Determine if the user is from New Zealand
 * @param  {string} country
 * @return {boolean}
 */
export const isNZCheck = ({ country }) => ((country || '').toLowerCase() === 'nz');